/**
 * Static-translations for zh. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const zh = {
  'anon.description_default': '正在设置访客会话…',
  'anon.heading_default': '以访客身份继续',
  'anon.try_again': '重试',
  'auth.back_to_login': '返回登录',
  'auth.check_email_message': '请查看邮件以获取确认码。',
  'auth.check_email_title': '请查看邮件',
  'auth.confirm_email_subtitle': '请输入我们发送到您邮箱的代码以完成注册。',
  'auth.confirm_email_title': '确认您的邮箱',
  'auth.confirmation_code': '确认码',
  'auth.continue_with_apple': '使用 Apple 继续',
  'auth.continue_with_facebook': '使用 Facebook 继续',
  'auth.continue_with_github': '使用 GitHub 继续',
  'auth.continue_with_google': '使用 Google 继续',
  'auth.create_account': '创建账户',
  'auth.default_subtitle': '登录以访问所有功能并同步您的数据。',
  'auth.email': '邮箱地址',
  'auth.email_already_registered': '该邮箱已注册。请在下方使用密码或您注册时使用的账户登录。',
  'auth.email_exists': '该邮箱已注册账户。',
  'auth.email_not_confirmed': '请先确认您的邮箱。',
  'auth.forgot_password': '忘记密码?',
  'auth.forgot_password_title': '忘记密码?',
  'auth.forgot_subtitle': '输入您的邮箱,我们将向您发送密码重置链接。',
  'auth.generic_error': '出错了',
  'auth.have_account': '已有账户?',
  'auth.hide_password': '隐藏密码',
  'auth.identity_already_linked': '该账户已注册。请在下方登录。',
  'auth.invalid_credentials': '邮箱或密码错误',
  'auth.invalid_otp': '验证码无效或已过期。',
  'auth.last_used': '上次使用 · {email}',
  'auth.last_used_no_email': '上次使用',
  'auth.link_purchase_subheading': '我们将把购买关联到您的账户以保留访问权限。',
  'auth.log_in': '登录',
  'auth.log_in_link': '登录',
  'auth.login_continue_purchase': '登录以继续购买',
  'auth.network_error': '网络错误。请检查连接后重试。',
  'auth.new_password_optional': '新密码（可选 — 仅用于密码重置）',
  'auth.no_account': '没有账户?',
  'auth.or': '或',
  'auth.password': '密码',
  'auth.passwords_mismatch': '密码不匹配',
  'auth.rate_limited': '请求过多，请稍后再试。',
  'auth.repeat_password': '重复密码',
  'auth.reset_link_valid': '链接有效期为 1 小时。',
  'auth.reset_password_subtitle': '请输入邮件中的代码和新密码。',
  'auth.reset_password_title': '重置密码',
  'auth.reset_sent_message': '如果该邮箱存在，已发送重置码。',
  'auth.reset_sent_subtitle': '我们已发送密码重置链接。请按邮件中的说明操作。',
  'auth.restore_purchases_heading': '恢复购买',
  'auth.restore_purchases_subheading': '请登录以恢复您的购买。',
  'auth.send_reset': '发送重置邮件',
  'auth.service_unavailable': '服务暂时不可用，请稍后再试。',
  'auth.show_password': '显示密码',
  'auth.sign_out': '退出',
  'auth.sign_up': '注册',
  'auth.sign_up_link': '注册',
  'auth.signed_in': '已登录',
  'auth.signin_failed': '登录失败',
  'auth.signup_failed': '注册失败',
  'auth.verify': '验证',
  'auth.weak_password': '密码强度太弱。',
  'auth.welcome': '欢迎!',
  'auth.welcome_signup': '欢迎！',
  'countdown.d': '天',
  'countdown.h': '小时',
  'countdown.m': '分',
  'countdown.s': '秒',
  'cta.close': '关闭',
  'cta.continue': '继续',
  'cta.get_lifetime_access': '获取终身访问',
  'cta.get_plan_daily': '获取日付计划',
  'cta.get_plan_generic': '获取 {interval} 计划',
  'cta.get_plan_monthly': '获取每月计划',
  'cta.get_plan_weekly': '获取每周计划',
  'cta.get_plan_yearly': '获取年度计划',
  'cta.start_trial': '开始{days}天免费试用',
  'modal.close_aria': '关闭',
  'modal.continue': '继续',
  'modal.error_generic': '出错了',
  'modal.loading': '加载中…',
  'modal.purchase_restored_subtitle': '一切就绪 — 尽情享受吧！',
  'modal.purchase_restored_title': '欢迎回来',
  'modal.purchase_success_subtitle': '一切就绪 — 尽情享受吧！',
  'modal.purchase_success_title': '已收到付款',
  'modal.verifying_subscription': '正在检查您的订阅…',
  'nav.back': '← 返回',
  'nav.back_aria': '返回',
  'offer.limited_time': '限时优惠',
  'payment.awaiting_subtitle': '我们将自动检测付款 — 或在完成后点击下方按钮。',
  'payment.awaiting_title': '在新标签页中完成付款',
  'payment.checking': '正在检查…',
  'payment.ive_paid': '我已付款',
  'payment.open_checkout_again': '重新打开结账',
  'payment.open_checkout_button': '打开结账',
  'payment.popup_blocked_message': '您的浏览器阻止了结账标签页。点击下方打开。',
  'payment.popup_blocked_title': '允许弹出窗口以继续',
  'payment.popup_help_text': '结账窗口未打开或被阻止？点击此处重新打开。',
  'payment.still_processing': '付款仍在处理中。请稍后再试。',
  'payment.tab_closed_retry': '关闭了标签页？重试',
  'pricing.free_trial_days': '{days}天免费试用',
  'pricing.included_per': '每{interval}包含:',
  'pricing.interval.day': '天',
  'pricing.interval.lifetime_short': '永久',
  'pricing.interval.month': '月',
  'pricing.interval.period': '周期',
  'pricing.interval.week': '周',
  'pricing.interval.year': '年',
  'pricing.money_back': '30天退款保证',
  'pricing.most_popular': '最受欢迎',
  'pricing.no_prices': '暂无价格。',
  'pricing.plan_label.daily': '日付计划',
  'pricing.plan_label.lifetime': '终身',
  'pricing.plan_label.monthly': '每月套餐',
  'pricing.plan_label.weekly': '每周套餐',
  'pricing.plan_label.yearly': '每年套餐',
  'pricing.plans_aria': '计划',
  'session.contact_support': '联系支持',
  'session.restore_purchases': '恢复购买',
  'session.sign_out': '退出',
  'session.signed_in_as_prefix': '已登录为',
  'session.signing_out': '退出中…',
  'support.attachments_aria': '上传附件',
  'support.attachments_label': '附件',
  'support.close_button': '关闭',
  'support.done_button': '完成',
  'support.dropzone_text': '将图片拖放到此处或点击选择',
  'support.email_placeholder': '输入您的邮箱',
  'support.file_requirements': 'JPEG/PNG/WebP，最多 {max} 个文件，每个 ≤ {size}MB',
  'support.heading': '支持',
  'support.instruction': '请填写下方表单以提交您的支持请求。',
  'support.invalid_email': '无效的邮箱',
  'support.invalid_file': '仅限 JPEG/PNG/WebP，每个 ≤ {size}MB',
  'support.message_length': '1-5000个字符',
  'support.message_placeholder': '输入您的消息',
  'support.remove_file_aria': '移除 {filename}',
  'support.required': '必填',
  'support.send_another': '发送另一个请求',
  'support.send_button': '发送',
  'support.sending': '发送中…',
  'support.sending_as': '以以下身份发送',
  'support.subject_length': '3-200个字符',
  'support.subject_placeholder': '输入主题',
  'support.success_heading': '请求已提交',
  'support.success_message_prefix': '我们已收到您的消息,将回复至',
  'support.too_many_files': '最多 {max} 个文件'
} as const;

export default zh;
